import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
} from '@razorpay/blade/components';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import { getCalculations } from '../utils';

function SalaryStructureComponentDetails({
  salaryComponents,
}: {
  salaryComponents: SalaryStructureComponent[] | undefined;
}) {
  if (!salaryComponents || salaryComponents.length === 0) {
    return null;
  }

  const data = { nodes: salaryComponents };

  return (
    <Table data={data}>
      {(tableData) => (
        <>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCell>{'Component'}</TableHeaderCell>
              <TableHeaderCell>{'Calculations'}</TableHeaderCell>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {tableData.map((component: any) => {
              const { id, salaryComponent } = component;

              return (
                <TableRow key={id} item={component}>
                  <TableCell>
                    <Text size="small" weight="regular" color="surface.text.gray.muted">
                      {salaryComponent.name}
                    </Text>
                  </TableCell>

                  <TableCell>
                    <Text size="small" weight="medium" color="surface.text.gray.normal">
                      {getCalculations(component)}
                    </Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </>
      )}
    </Table>
  );
}

export default SalaryStructureComponentDetails;
